export class UpdateWorkspaceBucketPolicyInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policyDocument",
            "baseName": "policyDocument",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceBucketPolicyInput.attributeTypeMap;
    }
    constructor() {
    }
}
